module.exports = __webpack_public_path__ + "img/RegisterD.a4f9c2c2.png";